module.exports = __webpack_public_path__ + "img/notAvailable.bab66bab.png";